import { ConfigFieldType, RulesRHF, TextInputFieldData } from 'adapter/in/common/form/types';
import useNumberContainer from 'adapter/in/common/form/Number/useNumberContainer';
import FormInputNumber from 'adapter/in/common/components/Number';
import PresetFormFieldProperties from 'domain/entity/preset/form/presetFormFieldProperties';
import React, { ReactElement } from 'react';

type NumberInputContainerProps = {
    name: string;
    label: string;
    configType: ConfigFieldType;
    footer: string;
    dataDependsOn?: string[];
    defaultValue?: TextInputFieldData;
    properties?: PresetFormFieldProperties;
    rules?: RulesRHF;
};

const NumberInputContainer = ({
    name,
    label,
    configType,
    footer,
    properties,
    dataDependsOn,
    defaultValue,
    rules,
}: NumberInputContainerProps): ReactElement => {
    const { value, handleOnChange, invalid, error } = useNumberContainer(name, configType, rules, dataDependsOn, defaultValue);
    return (
        <FormInputNumber
            name={name}
            label={label}
            properties={properties}
            onChange={handleOnChange}
            isLoading={false}
            error={invalid}
            errorMessage={error}
            dataTestId='number'
            footer={footer}
            value={value}
        />
    );
};

export default NumberInputContainer;
